import "./styles.css";
import Requirements from "./Requirements";
import TodoList from "./TodoList";

export default function App() {
  return (
    <div className="App">
      <Requirements />
      <TodoList />
    </div>
  );
}
